import React from "react";
import { TableCell, TableRow, Box, Typography } from "@mui/material";
import {useSelector} from "react-redux";
import PropTypes from "prop-types";
import { POSITIVE_COLOR, NEGATIVE_COLOR, VALUE_FONT_WEIGHT } from "../../Constants";
import {selectBudget} from "../../store/budgetSlice";
import {useTranslation} from "react-i18next";

const ChangeBudget = ({ transaction, onClick }) => {
    const {t} = useTranslation();
    const description = transaction.description || t("common.transactionType.changeBudget");
    const changes = transaction.changes ?? [];
    const budget = useSelector(state => selectBudget(state, transaction.budget));

    const formatValue = (value) => {
        if (value == null) return "—";
        const num = Number(value);
        if (num > 0) return `+${value}`;
        return String(value);
    };

    const getValueColor = (value) => {
        if (value == null) return "inherit";
        const num = Number(value);
        if (num > 0) return POSITIVE_COLOR;
        if (num < 0) return NEGATIVE_COLOR;
        return "inherit";
    };

    const isDraft = transaction?.state === "DRAFT";

    return (
        <TableRow
            key={transaction.id}
            className={isDraft ? "Draft" : undefined}
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            onClick={(event) => onClick(transaction)}
        >
            <TableCell padding="none" sx={{ width: 56 }} />
            <TableCell component="th" scope="row">
                <Typography variant="body1">{description}</Typography>
                <Typography variant="body2" color="text.secondary">{budget?.name || "—"}</Typography>
            </TableCell>
            <TableCell align="right">
                <Typography variant="body1" component="span" sx={{ display: "block", textAlign: "right" }}>
                    {changes.length > 0 ? (
                        <Box component="span" sx={{ display: "inline-flex", gap: 0.5, flexWrap: "wrap", justifyContent: "flex-end" }}>
                            {changes.map((c, i) => (
                                <React.Fragment key={c.currency ?? i}>
                                    {i > 0 && <Box component="span">, </Box>}
                                    <Box component="span" sx={{ color: getValueColor(c.value), fontWeight: VALUE_FONT_WEIGHT }}>
                                        {formatValue(c.value)}
                                    </Box>
                                </React.Fragment>
                            ))}
                        </Box>
                    ) : (
                        "—"
                    )}
                </Typography>
            </TableCell>
        </TableRow>
    );
};

ChangeBudget.propTypes = {
    transaction: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        description: PropTypes.string,
        budget: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        changes: PropTypes.arrayOf(
            PropTypes.shape({
                currency: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            })
        ),
    }).isRequired,
    onClick: PropTypes.func.isRequired,
};

export default ChangeBudget;
